import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return !!isMobile
}

const DOCK_BREAKPOINT = 1024

/**
 * True when there is room to dock the library rail beside the content.
 *
 * Below this the rail becomes an overlay drawer, which is the only width where
 * covering the page is the right call. It is a JS check rather than a `lg:`
 * class because `role="dialog"`, `aria-modal` and the Escape handler have to
 * come and go with it — a docked rail that still announces itself as a modal
 * traps screen-reader users in navigation they never opened.
 */
export function useIsDocked() {
  const [isDocked, setIsDocked] = React.useState(
    () => typeof window !== "undefined" && window.innerWidth >= DOCK_BREAKPOINT,
  )

  React.useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${DOCK_BREAKPOINT}px)`)
    const onChange = (event: MediaQueryListEvent) => setIsDocked(event.matches)
    mql.addEventListener("change", onChange)
    setIsDocked(mql.matches)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isDocked
}
